import { render, staticRenderFns } from "./SummaryPanel.vue?vue&type=template&id=61ab693b&"
import script from "./SummaryPanel.vue?vue&type=script&lang=js&"
export * from "./SummaryPanel.vue?vue&type=script&lang=js&"
import style0 from "./SummaryPanel.vue?vue&type=style&index=0&id=61ab693b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports